import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

function PrivacyAcceptanceModal() {
  const { apiRequest } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPolicy, setShowPolicy] = useState(false);
  const [policyHtml, setPolicyHtml] = useState(null);
  const [policyLoading, setPolicyLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const loadPolicy = async () => {
    if (policyHtml) {
      setShowPolicy(true);
      return;
    }
    setPolicyLoading(true);
    try {
      const response = await fetch("/api/privacy/informativa");
      const html = await response.text();
      setPolicyHtml(html);
      setShowPolicy(true);
    } catch (err) {
      setError("Impossibile caricare l'informativa privacy");
    } finally {
      setPolicyLoading(false);
    }
  };

  const handleAccept = async () => {
    if (!accepted) return;
    setLoading(true);
    setError(null);
    try {
      await apiRequest("/auth/accept-privacy", { method: "POST" });
      // Reload page to refresh user profile with privacy accepted
      window.location.reload();
    } catch (err) {
      setError(err.message || "Errore durante l'accettazione della privacy");
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">
            Informativa Privacy
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Per accedere al portale è necessario prendere visione e accettare
            l'informativa sul trattamento dei dati personali.
          </p>
        </div>

        {/* Content */}
        <div className="px-6 py-4 flex-1 overflow-y-auto">
          {showPolicy && policyHtml ? (
            <div className="mb-4">
              <div className="border rounded-lg p-4 bg-gray-50 max-h-64 overflow-y-auto">
                <iframe
                  srcDoc={policyHtml}
                  title="Informativa Privacy"
                  className="w-full h-64 border-0"
                  sandbox=""
                />
              </div>
              <button
                onClick={() => setShowPolicy(false)}
                className="mt-2 text-sm text-primary-600 hover:text-primary-700"
              >
                Chiudi informativa
              </button>
            </div>
          ) : (
            <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-800 mb-3">
                Ai sensi degli artt. 13-14 del Regolamento UE 2016/679 (GDPR), è
                necessario prendere visione dell'informativa sul trattamento dei
                dati personali prima di utilizzare il portale.
              </p>
              <button
                onClick={loadPolicy}
                disabled={policyLoading}
                className="text-sm font-medium text-primary-600 hover:text-primary-700 underline"
              >
                {policyLoading
                  ? "Caricamento..."
                  : "Leggi l'informativa privacy completa"}
              </button>
            </div>
          )}

          {/* Checkbox */}
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-1 h-4 w-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">
              Dichiaro di aver letto e compreso l'
              <button
                onClick={loadPolicy}
                className="text-primary-600 hover:text-primary-700 underline font-medium"
              >
                informativa privacy
              </button>{" "}
              e acconsento al trattamento dei miei dati personali per le
              finalità ivi descritte.
            </span>
          </label>

          {/* Error */}
          {error && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 rounded-b-xl">
          <button
            onClick={handleAccept}
            disabled={!accepted || loading}
            className="w-full btn-primary py-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Salvataggio...
              </span>
            ) : (
              "Accetto e prosegui"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyAcceptanceModal;
